import { useRouter } from 'next/router';
import { useContext } from 'react';

import { ContestManageModalsContext } from '../../../components/Modals/ContestManageModalsContext';

type UseSportStyleChangeHandlerProps = {
  sectionKey: string;
  fieldKey: string;
  currentValue: string | undefined;
};

export function useSportStyleChangeHandler({
  sectionKey,
  fieldKey,
  currentValue,
}: UseSportStyleChangeHandlerProps) {
  const router = useRouter();
  const { openModal } = useContext(ContestManageModalsContext);
  const currentQuery = router.query;

  const handleSportStyleChange = (newValue: string) => {
    const isSportGameStyleField =
      (sectionKey === 'gameplay' || sectionKey === 'form') &&
      (fieldKey === 'leagueId' || fieldKey === 'contestTemplateId');

    const isCreateOperation = router.pathname === '/contest/create';
    const hasExistingParams = currentQuery.leagueId && currentQuery.contestTemplateId;
    const isChangingFromExisting = currentValue && currentValue !== newValue;

    if (isSportGameStyleField && isCreateOperation && hasExistingParams && isChangingFromExisting) {
      const changeType = fieldKey === 'leagueId' ? 'league' : 'contestType';
      const newLeagueId = fieldKey === 'leagueId' ? newValue : currentQuery.leagueId;
      const newContestTemplateId =
        fieldKey === 'contestTemplateId' ? newValue : currentQuery.contestTemplateId;

      const handleConfirm = () => {
        if (changeType === 'league' && newLeagueId) {
          const newUrl = `${router.pathname}?leagueId=${newLeagueId}`;
          window.location.href = newUrl;
        } else if (changeType === 'contestType' && newContestTemplateId) {
          currentQuery.contestTemplateId = newContestTemplateId as string;

          const queryString = new URLSearchParams(
            currentQuery as Record<string, string>
          ).toString();
          const newUrl = `${router.pathname}?${queryString}`;
          window.location.href = newUrl;
        }
      };

      openModal({
        type: 'GameplayDiscardModal',
        changeType,
        onConfirm: handleConfirm,
      });

      return true;
    }

    return false;
  };

  return {
    handleSportStyleChange,
  };
}
